export default (props = {}) => <svg width="12" height="9" viewBox="0 0 12 9" xmlns="http://www.w3.org/2000/svg"{...props}>
<path d="M5.20759 1.02937C5.6079 0.509358 6.39211 0.509358 6.79241 1.02937L11.6888 7.39001C12.195 8.04757 11.7263 9 10.8964 9L1.10358 9C0.273737 9 -0.195026 8.04757 0.311171 7.39001L5.20759 1.02937Z" fill="black"/>
</svg>
